// extracted by mini-css-extract-plugin
module.exports = {"container":"V7JxFl","circle1":"hEgvYX","circle2":"_2-o58I"};